import { CustomSkillsSettings } from './custom-skills-settings';
import { NotificationSettings } from './notification-settings';
import { OutlookConnectSettings } from './outlook-connect-settings';

/**
 * Dedicated settings panel component for chat area.
 * Displays settings content inline within the main chat content area
 * instead of as a modal dialog overlay.
 *
 * Provides SettingsPanelContext so any settings card can push a full-panel
 * sub-view (e.g. the Outlook manage view) without this component needing to
 * know what's inside it.
 */
export function ChatSettingsPanel() {
  return (
    <div className="flex size-full min-h-0 min-w-0 flex-col">
      <div className="flex min-h-0 flex-1 items-start justify-center overflow-y-auto p-6">
        <div className="flex w-full max-w-md flex-col gap-4">
          <NotificationSettings />
          <CustomSkillsSettings />
          <OutlookConnectSettings />
        </div>
      </div>
    </div>
  );
}
